import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=fd6e3bc4&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd6e3bc4')) {
      api.createRecord('fd6e3bc4', component.options)
    } else {
      api.reload('fd6e3bc4', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=fd6e3bc4&", function () {
      api.rerender('fd6e3bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Tabs/Comments.vue"
export default component.exports